var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMais1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1486 8C15.1486 4.34427 12.185 1.38071 8.52927 1.38071C4.87353 1.38071 1.90998 4.34427 1.90998 8C1.90998 11.6557 4.87353 14.6193 8.52927 14.6193C12.185 14.6193 15.1486 11.6557 15.1486 8ZM8.52927 0C12.9475 0 16.5293 3.58172 16.5293 8C16.5293 12.4183 12.9475 16 8.52927 16C4.11099 16 0.529266 12.4183 0.529266 8C0.529266 3.58172 4.11099 0 8.52927 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52925 4.06104C8.91052 4.06104 9.2196 4.37012 9.2196 4.75139V11.2489C9.2196 11.6301 8.91052 11.9392 8.52925 11.9392C8.14798 11.9392 7.83889 11.6301 7.83889 11.2489V4.75139C7.83889 4.37012 8.14798 4.06104 8.52925 4.06104Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59021 7.99993C4.59021 7.61865 4.89929 7.30957 5.28057 7.30957H11.778C12.1593 7.30957 12.4684 7.61865 12.4684 7.99993C12.4684 8.3812 12.1593 8.69028 11.778 8.69028H5.28057C4.89929 8.69028 4.59021 8.3812 4.59021 7.99993Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMais1);
export default __webpack_public_path__ + "static/media/icon_mais1.2618ca27857672800f1ca2dc11ee48d8.svg";
export { ForwardRef as ReactComponent };